// Pure arithmetic for the stopwatch. No React, no storage, no clock of its own
// -- callers pass the elapsed milliseconds in.

// Past this, assume the timer was left running rather than worked through, and
// ask before banking it. Eight hours is a full day: anything longer is almost
// certainly a timer someone forgot on Friday afternoon.
export const OVERNIGHT_MS = 8 * 3600000;

const pad = (n) => String(Math.floor(n)).padStart(2, "0");

// Hours are NOT wrapped at 24: a timer left on overnight should read "26:03:00"
// and look obviously wrong, not reset to a plausible-looking "02:03:00".
export function formatElapsed(ms) {
  const total = Math.max(0, Math.floor(ms / 1000));
  return `${pad(total / 3600)}:${pad((total % 3600) / 60)}:${pad(total % 60)}`;
}

// Time is booked in quarter hours everywhere else in this grid, so a stopwatch
// reading has to land on one too. Floored at a quarter: a two-minute timer is
// still a real interruption, and a 0.00 line helps nobody.
export function bankableHours(ms) {
  const quarters = Math.round(Math.max(0, ms) / 900000);
  return Math.max(0.25, quarters * 0.25);
}

export function isOvernight(ms) {
  return ms > OVERNIGHT_MS;
}
